import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import PopNomemberSmsSendingOrder from './_PopNomemberSmsSendingOrder';
function PopCallRegister(props) {
  const {open, close} = props;
  const [modalSmsSendingOrder, setModalSmsSendingOrder] = useState(false);
  return (
    <Modal open={open} close={close} type="pop_call_register" popSize="s">
      <h2 className="pop_tit">전화수신</h2>
      <div className="content_container scroll">
        <div className="com_board_box">
          <div className="board_item">
            <div className="info">
              <div className="tit">수신자</div>
              <div className="cont">홍관리320</div>
            </div>
            <div className="info">
              <div className="tit">수신일시</div>
              <div className="cont">2023, 05, 13 15:30</div>
            </div>
            <div className="info">
              <div className="tit">수신번호</div>
              <div className="cont">010-1234-1324</div>
            </div>
            <div className="info">
              <div className="tit">발신자 명</div>
              <div className="cont">
                <input type="text" className="input" placeholder="발신자 명 입력" />
              </div>
            </div>
          </div>
        </div>
        <div className="radio_wrap">
          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
          <label htmlFor="rdo_01">비회원 문의</label>
          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
          <label htmlFor="rdo_02">홍보성 전화</label>
          <input type="radio" name="rdo" id="rdo_03" className="com_chk circle" />
          <label htmlFor="rdo_03">잘못걸린 전화</label>
          <input type="radio" name="rdo" id="rdo_04" className="com_chk circle" />
          <label htmlFor="rdo_04">출판관련</label>
          <input type="radio" name="rdo" id="rdo_05" className="com_chk circle" />
          <label htmlFor="rdo_05">협력업체</label>
          <input type="radio" name="rdo" id="rdo_06" className="com_chk circle" />
          <label htmlFor="rdo_06">회원문의</label>
          <input type="radio" name="rdo" id="rdo_07" className="com_chk circle" />
          <label htmlFor="rdo_07">직원문의</label>
          <input type="radio" name="rdo" id="rdo_08" className="com_chk circle" />
          <label htmlFor="rdo_08">교사문의</label>
          <input type="radio" name="rdo" id="rdo_09" className="com_chk circle" />
          <label htmlFor="rdo_09">관공서</label>
          <input type="radio" name="rdo" id="rdo_10" className="com_chk circle" />
          <label htmlFor="rdo_10">부산지사</label>
          <input type="radio" name="rdo" id="rdo_11" className="com_chk circle" />
          <label htmlFor="rdo_11">기타</label>
        </div>
        <textarea className="textarea" placeholder="메모 내용 입력"></textarea>
        <div className="com_divider" />
        <div className="notice_txt">※ 아래 수신자에게 5분 간격으로 문자가 발송 됩니다.</div>
        <table className="com_board_list">
          <colgroup>
            <col width="14%" />
            <col width="43%" />
            <col width="43%" />
          </colgroup>
          <thead>
            <tr>
              <th>순서</th>
              <th>수신자</th>
              <th>전화번호</th>
            </tr>
          </thead>
          <tbody>
            {[1, 2, 3, 4, 5].map((i, idx) => {
              return (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>
                    <button className="btn_link">김등록103</button>
                  </td>
                  <td>010-2134-2333</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="btn_container">
        <button
          onClick={() => {
            setModalSmsSendingOrder(true);
          }}
          className="com_btn gray s "
        >
          비회원문의 문자 전송 순서
        </button>
        <button className="com_btn orange xs">등록</button>
        <PopNomemberSmsSendingOrder open={modalSmsSendingOrder} close={() => setModalSmsSendingOrder(false)} />
      </div>
    </Modal>
  );
}

export default PopCallRegister;
